/* istanbul ignore file */
import { ExperienceTemplateRenderer, ExperienceTemplateRendererContextProvider } from 'experience-template-renderer-react';
import { ExperimentStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { PageLayoutStore } from 'stores/page-layout/page-layout-store';

import { componentLibrary } from 'components/search/template-components';
import { listViewTemplate } from 'templates/search/list-view.template';

interface TemplateRendererProps {
  experiment?: ExperimentStore;
  pageLayout?: PageLayoutStore;
  multiItem?: MultiItemStore;
}
export const TemplateRenderer: React.FC<TemplateRendererProps> = inject(
  'experiment',
  'pageLayout',
  'multiItem'
)(
  observer(({ experiment, pageLayout, multiItem }) => {
    const useListViewTemplate =
      !multiItem?.isPackageShoppingPath() && experiment?.exposures?.EG_Property_Search_Query_Migration?.bucket === 1;

    return (
      <ExperienceTemplateRendererContextProvider library={componentLibrary}>
        <ExperienceTemplateRenderer
          templateComponents={
            useListViewTemplate ? listViewTemplate.components : pageLayout?.getSRPTemplate(pageLayout?.templateName)?.components ?? []
          }
        />
      </ExperienceTemplateRendererContextProvider>
    );
  })
);
